import { PanelChoice } from '@/types/panel'

export enum ReportTypeEnum {
  Vacancy = 'Vacancy',
  EVRequest = 'EVRequest',
  Support = 'Support',
  LeadCapture = 'LeadCapture',
  FieldMarketing = 'FieldMarketing',
  Maintenance = 'Maintenance',
  BathroomService = 'BathroomService',
  Feedback = 'Feedback',
  RoomRental = 'RoomRental',
}

export const REPORT_TYPE = [
  { id: ReportTypeEnum.Vacancy, name: 'Vacancy-Lead' },
  { id: ReportTypeEnum.EVRequest, name: 'EV Request Report' },
  { id: ReportTypeEnum.Support, name: 'QR Support Report' },
  { id: ReportTypeEnum.Maintenance, name: 'Maintenance Report' },
  { id: ReportTypeEnum.LeadCapture, name: 'Lead Capture' },
  { id: ReportTypeEnum.FieldMarketing, name: 'Field Marketing' },
  { id: ReportTypeEnum.BathroomService, name: 'Bathroom Service' },
  { id: ReportTypeEnum.Feedback, name: 'Feedback' },
  { id: ReportTypeEnum.RoomRental, name: 'Room Rental' },
].sort((a, b) => a.name.localeCompare(b.name))

export const COI_STATUS = [
  {
    label: 'Active',
    value: 'Active',
  },
  {
    label: 'Expired',
    value: 'Expired',
  },
  {
    label: 'Expiring',
    value: 'Expiring',
  },
  {
    label: 'PendingVerify',
    value: 'PendingVerify',
  },
  {
    label: 'Rejected',
    value: 'Rejected',
  },
]

export const COI_TYPE = [
  {
    label: 'Tenant',
    value: 'Tenant',
  },
  {
    label: 'Vendor',
    value: 'Vendor',
  },
]

export const INSURANCE_TYPE = [
  'Worker’s Compensation',
  'Commercial General Liability',
  'Commercial Automotive Liability',
  'Umbrella Liability',
  'Crime Insurance',
].map((item) => ({ label: item, value: item } as PanelChoice))
export const TEAM_OPTIONS = ['Engineering', 'Security', 'Cleaning', 'Property Team'].map((v) => ({
  label: v,
  value: v,
}))
export const TEAM_OPTIONS_PROOF = [
  'Product',
  'Implementation',
  'Sales',
  'Customer',
  'Engineering',
  'Account management',
  'Admin',
  'Customer',
].map((v) => ({
  label: v,
  value: v,
}))

export const InspectionColor = {
  Completed: ['#D8FFF7', 'C'],
  Overdue: ['#FFDBDB', 'O'],
  Upcoming: ['#FFF6DA', 'U'],
  NA: ['#FFF', 'NA'],
}
